export const resetUser = () => ({
  type: "RESET_USER",
});

export const signUp = (obj, history) => ({
  type: "SIGNUP",
  obj,
  history,
});

export const signUpSuccess = (data) => ({
  type: "SIGNUP_SUCCESS",
  data,
});

export const signUpFail = (error) => ({
  type: "SIGNUP_FAIL",
  error,
});

export const forgotPassword = (obj, history, redirectUrl) => ({
  type: "FORGOT_PASSWORD",
  obj,
  history,
  redirectUrl,
});

export const forgotPasswordSuccess = (payload) => ({
  type: "FORGOT_PASSWORD_SUCCESS",
  payload,
  data: payload,
});

export const forgotPasswordFail = (error) => ({
  type: "FORGOT_PASSWORD_FAIL",
  error,
});

export const logIn = (obj, history, redirectUrl) => ({
  type: "LOGIN",
  obj,
  history,
  redirectUrl,
});

export const logInSuccess = (payload) => ({
  type: "LOGIN_SUCCESS",
  payload,
  data: payload,
});

export const logInFail = (error) => ({
  type: "LOGIN_FAIL",
  error,
});

export const logOut = () => ({
  type: "LOGOUT",
});

export const logOutSuccess = () => ({
  type: "LOGOUT_SUCCESS",
});

export const logOutFail = (error) => ({
  type: "LOGOUT_FAIL",
  error,
});

export const getCurrentUser = () => ({
  type: "GET_CURRENT_USER",
});

export const getCurrentUserSuccess = (data) => ({
  type: "GET_CURRENT_USER_SUCCESS",
  data,
});

export const getCurrentUserFail = (error) => ({
  type: "GET_CURRENT_USER_FAIL",
  error,
});

export const getTaxInspectors = (obj) => ({
  type: "GET_TAX_INSPECTORS",
  obj,
});

export const getTaxInspectorsSuccess = (data) => ({
  type: "GET_TAX_INSPECTORS_SUCCESS",
  data,
});

export const getTaxInspectorsFail = (error) => ({
  type: "GET_TAX_INSPECTORS_FAIL",
  error,
});

export const addTaxInspectors = (obj) => ({
  type: "ADD_TAX_INSPECTORS",
  obj,
});

export const addTaxInspectorsSuccess = (data) => ({
  type: "ADD_TAX_INSPECTORS_SUCCESS",
  data,
});

export const addTaxInspectorsFail = (error) => ({
  type: "ADD_TAX_INSPECTORS_FAIL",
  error,
});

export const editTaxInspectors = (obj) => ({
  type: "EDIT_TAX_INSPECTORS",
  obj,
});

export const editTaxInspectorsSuccess = (data) => ({
  type: "EDIT_TAX_INSPECTORS_SUCCESS",
  data,
});

export const editTaxInspectorsFail = (error) => ({
  type: "EDIT_TAX_INSPECTORS_FAIL",
  error,
});

export const getUsersSurveys = (obj) => ({
  type: "GET_USERS_SURVEYS",
  obj,
});

export const getUsersSurveysSuccess = (data) => ({
  type: "GET_USERS_SURVEYS_SUCCESS",
  data,
});

export const getUsersSurveysFail = (error) => ({
  type: "GET_USERS_SURVEYS_FAIL",
  error,
});

export const clearUserSuccess = () => ({
  type: "CLEAR_USER_SUCCESS",
});

export const updateSurveyStatus = (obj) => ({
  type: "UPDATE_SURVEY_STATUS",
  obj,
});

export const updateSurveyStatusSuccess = (data) => ({
  type: "UPDATE_SURVEY_STATUS_SUCCESS",
  data,
});

export const updateSurveyStatusFail = (error) => ({
  type: "UPDATE_SURVEY_STATUS_FAIL",
  error,
});

export const updatePassword = (obj) => ({
  type: "UPDATE_PASSWORD",
  obj,
});

export const updatePasswordSuccess = (data) => ({
  type: "UPDATE_PASSWORD_SUCCESS",
  data,
});

export const updatePasswordFail = (error) => ({
  type: "UPDATE_PASSWORD_FAIL",
  error,
});
export const updatePhoneAndAddress = (obj) => ({
  type: "UPDATE_PHONE_ADDRESS",
  obj,
});

export const updatePhoneAndAddressSuccess = (data) => ({
  type: "UPDATE_PHONE_ADDRESS_SUCCESS",
  data,
});

export const updatePhoneAndAddressFail = (error) => ({
  type: "UPDATE_PHONE_ADDRESS_FAIL",
  error,
});
export const getActivityLogs = (obj) => ({
  type: "GET_ACTIVITY_LOGS",
  obj,
});

export const getActivityLogsSuccess = (data) => ({
  type: "GET_ACTIVITY_LOGS_SUCCESS",
  data,
});

export const getActivityLogsFail = (error) => ({
  type: "GET_ACTIVITY_LOGS_FAIL",
  error,
});
export const getAdminActivityLogs = (obj) => ({
  type: "GET_ADMIN_ACTIVITY_LOGS",
  obj,
});

export const getAdminActivityLogsSuccess = (data) => ({
  type: "GET_ADMIN_ACTIVITY_LOGS_SUCCESS",
  data,
});

export const getAdminActivityLogsFail = (error) => ({
  type: "GET_ADMIN_ACTIVITY_LOGS_FAIL",
  error,
});

export const forcedLogout = () => ({
  type: "FORCED_LOGOUT",
});
